import { t, onLangChange } from "../i18n/t";
import { chapterFromProgress } from "../scroll/progress";

export interface HudHandle {
  setProgress: (p: number) => void;
  showSandboxHud: (show: boolean) => void;
  root: HTMLElement;
}

export function mountHud(parent: HTMLElement): HudHandle {
  const root = document.createElement("div"); root.id = "hud";
  root.innerHTML = `
    <div id="caption"><h2></h2><p></p></div>
    <div id="sandbox-hud">
      <button data-k="photon" class="armed">γ</button>
      <button data-k="w">W</button>
      <button data-k="gluon">g</button>
      <button data-k="higgs">H</button>
      <button id="reset">${t("hud_reset")}</button>
      <button id="replay">${t("hud_replay")}</button>
    </div>`;
  parent.appendChild(root);

  const cap = root.querySelector("#caption") as HTMLElement;
  const capH = cap.querySelector("h2") as HTMLElement;
  const capP = cap.querySelector("p") as HTMLElement;

  let currentChapter = -1;
  function setProgress(p: number) {
    const ch = chapterFromProgress(p);
    if (ch !== currentChapter) {
      currentChapter = ch;
      capH.textContent = t(`ch${ch}_title`);
      capP.textContent = t(`ch${ch}_body`);
      cap.classList.add("show");
    }
  }

  const sandbox = root.querySelector("#sandbox-hud") as HTMLElement;
  const showSandboxHud = (show: boolean) => sandbox.classList.toggle("show", show);

  onLangChange(() => {
    if (currentChapter >= 0) {
      capH.textContent = t(`ch${currentChapter}_title`);
      capP.textContent = t(`ch${currentChapter}_body`);
    }
    (root.querySelector("#reset") as HTMLElement).textContent = t("hud_reset");
    (root.querySelector("#replay") as HTMLElement).textContent = t("hud_replay");
  });

  return { setProgress, showSandboxHud, root };
}
